// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_ByFranchiseResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payments/accounts/by_franchise/{franchise_id}
 *
 * Returns the sanitized subaccount object linked to the given franchise, or
 * null when no link exists. The shape is identical to the other single-account
 * endpoints (detalhe / atualizar_config): subaccounts_model->getByFranchise()
 * (which resolves the franchise's account_id then runs getById() — a
 * `subaccounts pa` row joined to `payment_providers pp`, with the 5 JSON
 * columns decoded into arrays and a `franchises` list appended) run through
 * sanitizeForFrontend() (which unset()s the 4 sensitive columns when present).
 *
 * Typed as the shared SubaccountsFranchises_AtualizarConfigRow; the only
 * free-form members are the 5 decoded-JSON blobs declared as justified
 * shape-erased arrays on that Row. dados is nullable for the no-link case.
 *
 * @see subaccounts_model.php::getByFranchise() / sanitizeForFrontend()
 */
import type { SubaccountsFranchises_AtualizarConfigRow } from './SubaccountsFranchises_AtualizarConfigRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type SubaccountsFranchises_ByFranchiseResponseDados = SubaccountsFranchises_AtualizarConfigRow;

export type SubaccountsFranchises_ByFranchiseResponse = ApiResponse<SubaccountsFranchises_ByFranchiseResponseDados>;

registerResponseContract('SubaccountsFranchises_ByFranchiseResponse', {
  _nullable:           { type: 'boolean', required: false },
  id:                  { type: 'number',  required: true },
  provider_id:         { type: 'number',  required: true },
  provider_account_id: { type: 'string',  required: false },
  wallet_id:           { type: 'string',  required: false },
  api_key:             { type: 'string',  required: false },
  name:                { type: 'string',  required: true },
  email:               { type: 'string',  required: false },
  document:            { type: 'string',  required: false },
  document_type:       { type: 'string',  required: false },
  phone:               { type: 'string',  required: false },
  address:             { type: 'object',  required: false },
  bank_account:        { type: 'object',  required: false },
  status:              { type: 'string',  required: true },
  config:              { type: 'object',  required: false },
  fiscal_config:       { type: 'object',  required: false },
  sandbox_mode:        { type: 'number',  required: true },
  webhook_token:       { type: 'string',  required: false },
  last_sync_at:        { type: 'string',  required: false },
  created_at:          { type: 'string',  required: true },
  updated_at:          { type: 'string',  required: true },
  anticipation_config: { type: 'object',  required: false },
  provider_code:       { type: 'string',  required: true },
  provider_name:       { type: 'string',  required: true },
  api_base_url:        { type: 'string',  required: true },
  sandbox_api_url:     { type: 'string',  required: true },
  franchises: {
    type: 'array',
    required: false,
    items: {
      id:           { type: 'number',  required: true },
      franchise_id: { type: 'number',  required: true },
      created_at:   { type: 'string',  required: false },
      franquia:     { type: 'string',  required: false },
    },
  },
})
